import hash from "object-hash";
function formatFinancialPrograms(payments, banks) {
  const extFinancialPrograms = payments.map((rawProgram) => {
    const { payment: _, bank: bankId, ...program } = rawProgram;
    const uid = hash({ ...program, bankId });
    return {
      ...rawProgram,
      bankId,
      bank: banks.find((bank) => bank.id === bankId),
      uid
    };
  }).sort((a, b) => Number(a.payment) - Number(b.payment));
  return extFinancialPrograms;
}
export {
  formatFinancialPrograms
};
